import { render, staticRenderFns } from "./editGo.vue?vue&type=template&id=c914d2da&scoped=true"
import script from "./editGo.vue?vue&type=script&lang=js"
export * from "./editGo.vue?vue&type=script&lang=js"
import style0 from "./editGo.vue?vue&type=style&index=0&id=c914d2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c914d2da",
  null
  
)

export default component.exports